export const TITLE = "TelePagos - Plataforma de Cobros";
export const loaderColor = "#0147BA";
